import { Checkbox } from '@nexelem/components';
import { useController } from 'react-hook-form';
import { isCheckedParameterValue, toBooleanParameterValue } from '../groupSimulationParameters';
import { ParameterLabel } from './ParameterLabel';

type BooleanParameterProps = {
  name: string;
  label: string;
};

export const BooleanParameter = ({ name, label }: BooleanParameterProps) => {
  const { field } = useController({ name });
  const checked = isCheckedParameterValue(field.value);

  return (
    <label className="flex cursor-pointer items-center gap-2 min-h-8" htmlFor={name}>
      <Checkbox
        checked={checked}
        id={name}
        name={field.name}
        onBlur={field.onBlur}
        onChange={(_, isChecked) => field.onChange(toBooleanParameterValue(isChecked))}
      />
      <ParameterLabel label={label} />
    </label>
  );
};
